import React, { Component } from 'react'

class CheckMessage extends Component {
  /**
   * Render.
   *
   * @return {JSX}
   */
  render() {
    switch (this.props.status) {
      case 1:
        return (
          <span>
            <span className="fa fa-check" />
          </span>
        )
      case 2:
        return (
          <span>
            <span className="fa fa-check" />
            <span className="fa fa-check" />
          </span>
        )
      case 3:
        return (
          <span>
            <span className="fa fa-check blue-primary" />
            <span className="fa fa-check blue-primary" />
          </span>
        )
      default:
        return null
    }
  }
}

export default CheckMessage
